import React from 'react';

type Status = 'Escalating' | 'Critical' | 'Monitoring' | 'Resolved' | 'Detected' | 'Classified';

const statusConfig: Record<Status, { bg: string; text: string }> = {
  Critical: { bg: 'bg-danger/10', text: 'text-danger' },
  Escalating: { bg: 'bg-orange-500/10', text: 'text-orange-400' },
  Monitoring: { bg: 'bg-info/10', text: 'text-info' },
  Detected: { bg: 'bg-warning/10', text: 'text-warning' },
  Classified: { bg: 'bg-muted', text: 'text-muted-foreground' },
  Resolved: { bg: 'bg-success/10', text: 'text-success' },
};

interface StatusBadgeProps {
  status: Status;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${config.bg} ${config.text}`}>
      {status}
    </span>
  );
}